<template>
  <el-form v-loading="loading" ref="ff" :model="detail" label-position="top">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="客户名称" prop="Customer" required>
          <el-autocomplete
            style="width: 100%"
            popper-class="nameComplete"
            :disabled="!!detail.Id && !!detail.Customer"
            v-model="detail.Customer"
            :fetch-suggestions="querySearch"
            @select="handleSelect"
            value-key="Name"
            :trigger-on-focus="false"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.Name }}</div>
              <span class="addr">{{ item.Name }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="到货时间" prop="ExpectDate">
          <el-date-picker
            v-model="detail.ExpectDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="非必填项"
            style="widht: 100%"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="申请单号" prop="Code">
          <el-input v-model="detail.Code" disabled placeholder="系统自动生成" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系地址" prop="Address">
          <el-input v-model="detail.Address" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式" class="flexItem">
          <el-input v-model="detail.Linkman" placeholder="联系人" />
          <el-input v-model="detail.Linktel" placeholder="联系电话" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item>
      <el-card shadow="never">
        <div slot="header" class="toolbar">
          <b>商品清单</b>
          <el-button-group>
            <el-button type="primary" size="mini" plain @click="onManually"
              >手动添加商品</el-button
            >
            <el-button type="primary" size="mini" plain @click="onPicker"
              >库存选择商品</el-button
            >
          </el-button-group>
        </div>
        <el-table :data="detail.Items">
          <el-table-column prop="Code" label="编码" min-width="80" />
          <el-table-column label="品名" min-width="150">
            <template slot-scope="{ row }">
              <p>{{ row.Name }} {{ row.Spec }}</p>
              <p class="describe">{{ row.Remarks }}</p>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="100">
            <el-input
              slot-scope="{ row }"
              v-model="row.Quantity"
              size="small"
              @blur="onRecalculate(row, 1)"
            >
              <template slot="append">{{ row.Unit }}</template>
            </el-input>
          </el-table-column>
          <el-table-column label="单价" width="120">
            <el-input
              slot-scope="{ row }"
              v-model="row.Price"
              size="small"
              @blur="onRecalculate(row, 1)"
            >
              <span style="padding: 0 5px; line-height: 32px" slot="prefix"
                >￥</span
              >
            </el-input>
          </el-table-column>
          <el-table-column label="总价" width="120">
            <el-input
              slot-scope="{ row }"
              v-model="row.Amount"
              size="small"
              @blur="onRecalculate(row, 2)"
            >
              <span style="padding: 0 5px; line-height: 32px" slot="prefix"
                >￥</span
              >
            </el-input>
          </el-table-column>
          <el-table-column min-width="60" align="center">
            <el-link slot="header" type="danger" @click="onClear">清空</el-link>
            <template slot-scope="scope">
              <el-link type="info" @click="setRowRemarks(scope.row)"
                >备注</el-link
              >
              <el-link type="danger" @click="onRemove(scope)">移除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-form-item>
    <el-form-item>
      <template slot="label" class="toolbar" style="width: 100%">
        <itemPicker typeId="presale-mode" style="flex: 1">
          <template slot-scope="{ data }">
            <b>申请备注：</b>
            <label style="margin-right: 10px">快捷输入</label>
            <el-link
              style="line-height: 1"
              type="primary"
              v-for="item in data"
              :key="item.Code"
              @click="onShortcut(item.Name)"
              >{{ item.Name }}</el-link
            >
          </template>
        </itemPicker>
      </template>
      <el-input type="textarea" rows="4" v-model="detail.Remarks" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">提交申请</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import picker from "@/views/product/stock/cart.vue";
import formpage from "./_product.vue";
export default {
  components: {
    itemPicker: () => import("@/views/system/meta/item/picker.vue"),
  },
  data() {
    return {
      loading: false,
      detail: { Items: [], Remarks: "" },
    };
  },
  created() {
    this.$apis.product.presale
      .detail({ id: this.$route.query.id })
      .then((res) => {
        if (res) {
          this.detail = res;
        }
      });
  },

  methods: {
    querySearch(queryString, cb) {
      //关键词输入提示
      this.$apis.organize.customer
        .list({ size: 10, keyWord: queryString })
        .then((res) => {
          let _adds = res.Items;
          var results = _adds.filter(this.createFilter(queryString));
          cb(results);
        });
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          `${restaurant.Name}${restaurant.Address}`
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) >= 0
        );
      };
    },
    handleSelect(item) {
      this.detail.Address = item.Address;
      this.detail.Linkman = item.Linkman;
      this.detail.Linktel = item.Linktel;
    },

    //选择商品
    onPicker() {
      this.$layer.iframe({
        title: "选择商品",
        area: ["1024px", "720px"],
        content: {
          content: picker,
          parent: this,
          data: {
            callback: (res) => {
              (this.detail.Items || []).push(...res);
            },
          },
        },
      });
    },
    //手动添加
    onManually() {
      this.$layer.iframe({
        title: "添加商品",
        area: ["480px", "auto"],
        content: {
          content: formpage,
          parent: this,
          data: {
            callback: (res) => {
              (this.detail.Items || []).push(res);
            },
          },
        },
      });
    },
    //移除行
    onRemove(scope) {
      this.detail.Items.splice(scope.$index, 1);
    },
    //清空行
    onClear() {
      this.detail.Items = [];
    },

    //计算价格
    onRecalculate(row, type = 1) {
      switch (type) {
        case 1: {
          this.$set(row, "Amount", (row.Price * row.Quantity).toFixed(2));
          break;
        }
        case 2: {
          this.$set(row, "Price", (row.Amount / row.Quantity).toFixed(2));
          break;
        }
      }
    },
    //设置行备注
    setRowRemarks(row) {
      this.$prompt(null, "设置备注", {
        inputType: "textarea",
        inputValue: row.Remarks,
        center: true,
      }).then(({ value }) => {
        this.$set(row, "Remarks", value);
      });
    },

    //备注快捷输入
    onShortcut(txt) {
      this.detail.Remarks += `\n${txt}`;
    },
    //提交数据
    onSubmit() {
      this.$refs["ff"].validate((valid) => {
        if (valid && !this.loading) {
          this.loading = true;
          this.$apis.product.presale
            .submit(this.detail)
            .then((res) => {
              this.$message({ message: "数据提交成功！", type: "success" });
              this.$router.replace({
                path: res.Id,
              });
            })
            .catch((e) => {
              this.$message.error(e || "执行错误");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.el-form {
  width: 72%;
  min-width: 960px;
  background: #fff;
  padding: 40px;
  min-height: 100%;
}
:deep(.el-input-group__append) {
  padding: 0 10px;
}
:deep(.el-card) {
  &__header {
    padding: 5px 10px;
  }
  &__body {
    padding: 0;
  }
}
</style>

<style lang="scss">
.nameComplete {
  li {
    padding: 7px 20px;
    line-height: normal;
    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>